import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

type ProductSizeColor = {
    id: string;
    name: string;
    quantity: number;
    price: number;
    description: string;
    createdAt: string;
    productId: string;
    sizeColorId: string;
    sizeId:string;
    colorId:string;
}

type AddProductSizeColorDTO = {
    name: string;
    quantity: number;
    price: number;
    description: string;
    createdAt: string;
    productId: string;
    sizeColorId: string;
}

export async function GetAllProductSize() {
    const response = await axios.get(`${getEndpoint()}/api/ProductSize/GetAll`, ngrokSkipWarning);
    return response.data;
}

export async function GetAvailableSizes(productId: string) {
    const response = await axios.get(`${getEndpoint()}/api/ProductSize/GetAvailableSizes?productId=${productId}`, ngrokSkipWarning);
    return response.data;
}

export async function GetProductSize(id: string) {
    const response = await axios.get(`${getEndpoint()}/api/ProductSize/GetAllByProductId?id=${id}`, ngrokSkipWarning);
    return response.data;
}

export async function AddProductSize(dto: any) {
    const response = await axios.post(`${getEndpoint()}/api/ProductSize/Add`, dto, ngrokSkipWarning);
    return response.data;
}

export async function UpdateProductSize(dto: any) {
    const response = await axios.put(`${getEndpoint()}/api/ProductSize/Update`, dto, ngrokSkipWarning);
    return response.data;
}

export async function DeleteProductSize(id: string) {
    const response = await axios.delete(`${getEndpoint()}/api/ProductSize/Delete?id=${id}`, ngrokSkipWarning);
    return response.data;
}
